export default "__VITE_ASSET__CJqpyy1t__"